import { useEffect, useState } from 'react';

function checkWebPSupport(callback: (isSupported: boolean) => void): void {
  const img = new Image();
  img.onload = () => callback(img.width > 0 && img.height > 0);
  img.onerror = () => callback(false);
  img.src =
    'data:image/webp;base64,' +
    'UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA'; // Test image data
}

export default function useDoesSupportWebp(): boolean {
  const [isSupported, setSupported] = useState<boolean>(true);

  useEffect(() => checkWebPSupport(setSupported), []);

  return isSupported;
}
